import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ab7df4f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "advertise_introduction_item"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "introduction_item_title"
};
const _hoisted_4 = {
  class: "introduction_item_des"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "introduction_icon_img",
    src: require(`@/assets/home-wrapper/index/advertise/${$props.options.icon}`),
    alt: ""
  }, null, 8, _hoisted_2), _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t($props.options.title)), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t($props.options.des)), 1)]);
}